import { SideMenu } from "../../../../../Wrap/Constants/Enums/Menu/SideMenu";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";

export class SubaccountSideMenuMap {
    public static getSubaccountSideMenu(menuString: string): SideMenu {
        let menu = menuString;
        if (menuString.includes("Personal Portfolio") || menuString.includes("PP - ")) {
            menu = "Personal Portfolio";
        }
        return this.getSideMenuMap().get(menu);
    }

    private static getSideMenuMap(): Map<string, SideMenu> {
        const map = new Map<string, SideMenu>();
        map.set("ISA Stocks & Shares", SideMenu.IsaStocks);
        map.set("Offshore Bond", SideMenu.OffshoreBond);
        map.set("SIPP", SideMenu.OldSipp);
        map.set("Personal Portfolio", SideMenu.PersonalPortfolio);
        map.set("Cash Account", SideMenu.WrapCash);
        map.set("Onshore Bond", SideMenu.OnshoreBond);
        map.set("ISA Cash", SideMenu.IsaCash);
        map.set("abrdn SIPP", SideMenu.NewSipp);
        map.set("Aberdeen SIPP", SideMenu.NewSipp);
        map.set("Aberdeen JSIPP", SideMenu.NewSipp);
        return map;
    }

    public static getSubaccountName(sideMenu: SideMenu): string {
        return this.getSubaccountNameMap().get(sideMenu);
    }

    private static getSubaccountNameMap(): Map<SideMenu, string> {
        const map = new Map<SideMenu, string>();
        map.set(SideMenu.IsaStocks, "ISA Stocks & Shares");
        map.set(SideMenu.OffshoreBond, "Offshore Bond");
        map.set(SideMenu.WrapCash, "Wrap Cash");
        map.set(SideMenu.OnshoreBond, "Onshore Bond");
        map.set(SideMenu.PersonalPortfolio, "Personal Portfolio");
        map.set(SideMenu.OldSipp, "SIPP");
        map.set(SideMenu.IsaCash, "ISA Cash");
        map.set(SideMenu.NewSipp, "abrdn SIPP");
        return map;
    }

    public static getSubMenuBySubAccountType(subAccountType: SubAccountType): SideMenu {
        return this.getSideMenuMapBySubAccountType().get(subAccountType);
    }

    private static getSideMenuMapBySubAccountType(): Map<SubAccountType, SideMenu> {
        const map = new Map<SubAccountType, SideMenu>();
        map.set(SubAccountType.StocksIsa, SideMenu.IsaStocks);
        map.set(SubAccountType.OffshoreBond, SideMenu.OffshoreBond);
        map.set(SubAccountType.Sipp, SideMenu.OldSipp);
        map.set(SubAccountType.PersonalPortfolio, SideMenu.PersonalPortfolio);
        map.set(SubAccountType.InvestmentAccount, SideMenu.PersonalPortfolio);
        map.set(SubAccountType.WrapCash, SideMenu.WrapCash);
        map.set(SubAccountType.OnshoreBond, SideMenu.OnshoreBond);
        map.set(SubAccountType.CashIsa, SideMenu.IsaCash);
        map.set(SubAccountType.Pension, SideMenu.NewSipp);
        map.set(SubAccountType.Npr, SideMenu.NewSipp);
        map.set(SubAccountType.JuniorSipp, SideMenu.NewSipp);
        return map;
    }

    public static IsSubAccountSideMenu(sideMenu: SideMenu): boolean {
        return !CommonHelper.isNullOrEmpty(this.getSubaccountNameMap().get(sideMenu));
    }
}
